const openModal = document.getElementById("openVideoModal");
const closeModal = document.getElementById("closeVideoModal");
const modal = document.getElementById("videoModal");
const iframe = document.getElementById("videoIframe");

if (modal) {
  const originalSrc = iframe.src;

  openModal.addEventListener("click", function () {
    modal.style.display = "flex";

    if (!iframe.src.includes("autoplay=1")) {
      iframe.src = `${originalSrc}${
        originalSrc.includes("?") ? "&" : "?"
      }autoplay=1`;
    }
  });

  closeModal.addEventListener("click", function () {
    modal.style.display = "none";
    iframe.src = originalSrc;
  });

  window.addEventListener("click", function (e) {
    if (e.target === modal) {
      modal.style.display = "none";
      iframe.src = originalSrc;
    }
  });
}
